import { Loader, TileFormSectionTitle, TileFormSpan } from '@dataplace.ai/ui-components/atoms'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { BOXES } from './utils/boxes'
import { getBoxIcon } from './utils/getBoxIcon'
import { ResultLabel, Box, BoxLabel, BoxRow, Circle, Wrapper } from './GenericBoxResult.styles'

interface GenericBoxResultProps {
  resultKey: string
  i18nKeys: {
    header: string
    paragraph: string
    activeLabel: string
  }
  loading: boolean
  hasData: boolean
}

export const GenericBoxResult: React.FC<GenericBoxResultProps> = ({
  resultKey,
  i18nKeys,
  loading,
  hasData,
}) => {
  const { t } = useTranslation()

  const boxElements = useMemo(() =>
    BOXES.map((box, idx) => {
      const isActive = box.key === resultKey
      return (
        <Box
          key={box.key}
          active={isActive}
          color={box.color}
        >
          <Circle>{getBoxIcon(idx, isActive)}</Circle>
          <BoxLabel isActive={isActive}>{t(box.label)}</BoxLabel>
          {isActive ? <ResultLabel>{t(i18nKeys.activeLabel)}</ResultLabel> : null}
        </Box>
      )
    }),
  [resultKey, t])

  if (loading || !hasData) return <Loader />

  return (
    <Wrapper>
      <TileFormSectionTitle>{t(i18nKeys.header)}</TileFormSectionTitle>
      <TileFormSpan>{t(i18nKeys.paragraph)}</TileFormSpan>
      <BoxRow>{boxElements}</BoxRow>
    </Wrapper>
  )
}
